/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PresaleAggregator,
  PresaleAggregatorInterface,
} from "../PresaleAggregator";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IToken",
        name: "_token",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "presale",
        type: "address",
      },
    ],
    name: "PresaleCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "presale",
        type: "address",
      },
    ],
    name: "addPresale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimFromAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "presale",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_limit",
        type: "uint64",
      },
    ],
    name: "connectNativePresale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "fund",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "presaleProgress",
    outputs: [
      {
        components: [
          {
            internalType: "uint64",
            name: "locked",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "limit",
            type: "uint64",
          },
        ],
        internalType: "struct PresaleAggregator.PresaleProgress",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "presales",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "presale",
        type: "address",
      },
    ],
    name: "removePresale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "limit",
        type: "uint64",
      },
    ],
    name: "setLimitToAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "status",
        type: "uint8",
      },
    ],
    name: "setStatusToAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "percent",
        type: "uint8",
      },
    ],
    name: "setUnlockedPercentToAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transferToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class PresaleAggregator__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _token: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PresaleAggregator> {
    return super.deploy(_token, overrides || {}) as Promise<PresaleAggregator>;
  }
  getDeployTransaction(
    _token: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_token, overrides || {});
  }
  attach(address: string): PresaleAggregator {
    return super.attach(address) as PresaleAggregator;
  }
  connect(signer: Signer): PresaleAggregator__factory {
    return super.connect(signer) as PresaleAggregator__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PresaleAggregatorInterface {
    return new utils.Interface(_abi) as PresaleAggregatorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PresaleAggregator {
    return new Contract(address, _abi, signerOrProvider) as PresaleAggregator;
  }
}
